import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import { handleAd } from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import { oneChangeTwoDimensional } from '../../../../utils/utils';
import { rel } from '../../../../utils/rel';

const formatList = (content, ads) => {
    const list = oneChangeTwoDimensional([...content], 2);

    for (const ad of ads) {
        if (ad.type === 'replaceArr') {
            list.splice(ad.index, 1, [{ type: 'ad', ref: ad.ref }]);
        } else if (ad.type === 'insertArr') {
            list.splice(ad.index, 0, [{ type: 'ad', ref: ad.ref }]);
        }
    }

    return list;
};

class BannerBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
    };

    state = {
        ads: [],
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const refs = [];

            replaceArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'replaceArr' });
            });

            insertArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'insertArr' });
            });

            this.setState(
                {
                    ads: [...this.state.ads, ...refs],
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        const { ad } = this.props;

        if (ad) {
            try {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }
    }

    /**
     * 渲染组件
     */
    render() {
        const { ads } = this.state;
        const { content } = this.props;
        const data = formatList(content, ads);

        /* eslint-disable no-confusing-arrow */
        return (
            <ul className={styles.list}>
                {data.map(
                    (item, index) =>
                        item[0].type === 'ad' ? (
                            <li key={index} className={styles.item} ref={item[0].ref} />
                        ) : (
                            <li key={index} className={styles.item}>
                                <div className={styles.pic}>
                                    <a href={item[1].url} target="_blank" rel={rel}>
                                        <img src={item[1].thumbnail} alt={item[1].title} title={item[1].title} />
                                        <div />
                                    </a>
                                </div>
                                <div className={styles.content}>
                                    <div className={styles.title}>
                                        <a href={item[0].url} target="_blank" rel={rel} title={item[0].title}>
                                            {item[0].title}
                                        </a>
                                    </div>
                                    <h4>
                                        <a
                                            href={item[1].url}
                                            target="_blank"
                                            rel={rel}
                                            sign-trs-href={item[1].url}
                                            title={item[1].title}>
                                            {item[1].title}
                                        </a>
                                    </h4>
                                </div>
                            </li>
                        ),
                )}
            </ul>
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(BannerBox);
